"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NON_HUBSPOT_PATH = exports.STYLES_PATH = exports.SUBMISSIONS_SETTINGS_PATH = exports.MODULE_PATH = exports.BASE_FORMS_TAB_ROUTE = void 0;
var BASE_FORMS_TAB_ROUTE = 'marketing/form';
exports.BASE_FORMS_TAB_ROUTE = BASE_FORMS_TAB_ROUTE;
var MODULE_PATH = 'form';
exports.MODULE_PATH = MODULE_PATH;
var SUBMISSIONS_SETTINGS_PATH = 'submissionssettings';
exports.SUBMISSIONS_SETTINGS_PATH = SUBMISSIONS_SETTINGS_PATH;
var STYLES_PATH = 'styles';
exports.STYLES_PATH = STYLES_PATH;
var NON_HUBSPOT_PATH = 'non-hubspot';
exports.NON_HUBSPOT_PATH = NON_HUBSPOT_PATH;